<script setup lang="ts">
import { localize } from "@/utils";
</script>
<template>
  <div id="ct" class="flex-layout-body" data-bg="welcome">
    <div class="d-flex justify-content-between w-100 mb-4">
      <div class="welcome-wrap d-flex flex-column justify-content-between">
        <div>
          <b>Welcome!</b>
          <span class="fs-4">
            {{ localize("플래너로서의 시작을 축하합니다.") }}<br />
            {{ localize("이제 아래 단계를 따라 제공할 서비스를 설정해 보세요!") }}
          </span>
        </div>
        <p class="fs-2">{{ localize("플래너로서의 첫 시작, 무엇을 해야할까요?") }}</p>
      </div>
      <img src="@/assets/playground/img/welcome.png" alt="" />
    </div>
    <ul class="row card-row">
      <li class="col-4">
        <div class="card service-item bg-white">
          <div class="card-body">
            <div class="mb-3">
              <img src="@/assets/playground/img/order-management-step1.png" alt="" />
              <b class="d-block fs-4 text-primary mt-3">STEP 1</b>
              <p class="fs-3">{{ localize("주문자가 가장 먼저 보게 될 [서비스 프로필]을 설정해주세요.") }}</p>
              <span class="d-block fs-sm mt-2">{{
                localize("주문자와 만나는 가장 첫 단계. 나를 소개하는 프로필을 작성해주세요.")
              }}</span>
            </div>
            <router-link to="/" class="btn btn-block btn-lg">{{ localize("서비스 프로필 설정하러 가기") }}</router-link>
          </div>
        </div>
      </li>
      <li class="col-4">
        <div class="card service-item bg-white">
          <div class="card-body d-flex flex-column justify-content-between">
            <div class="mb-3">
              <img src="@/assets/playground/img/order-management-step2.png" alt="" />
              <b class="d-block fs-4 text-primary mt-3">STEP 2</b>
              <p class="fs-3">{{ localize("내가 제공할 수 있는 서비스를 등록하세요.") }}</p>
              <span class="d-block fs-sm mt-2">{{ localize("내가 제공할 서비스들을 등록해주세요.") }}</span>
            </div>
            <router-link to="/" class="btn btn-block btn-lg">{{ localize("서비스 등록하러 가기") }}</router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<style scoped></style>
